import { inject, provideAppInitializer } from '@angular/core';

import { CopyService } from './copy.service';

/**
 * Provides an app initializer that loads copy data before app bootstrap.
 * This ensures all copy/translations are loaded before any component renders.
 *
 * Add this to your app.config.ts providers array.
 *
 * @example
 * ```typescript
 * import { provideCopyInitializer } from '@amfam/shared/utility/shared-services/lib/copy/copy-initializer';
 *
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideCopyInitializer(),
 *     // ... other providers
 *   ]
 * };
 * ```
 */
export function provideCopyInitializer() {
  return provideAppInitializer(() => {
    const copyService = inject(CopyService);
    return copyService.ensureCopyLoaded();
  });
}
